import React, { useContext } from 'react';
import SearchContentNotifications from 'Components/Header/SearchContentNotifications';
import NotificationContent from 'Components/Notifications/NotificationContent';
import { Context } from 'Context/Context';

function ProfNotificationsWithoutHeader({ attorney, setLoadNotification }) {
  const {userDetails} = useContext(Context);
  const userInfo = attorney ? attorney.userId : userDetails;
  return (
    <div className='flex col-span-6 w-full flex-col font-plexsans' style={{ background: '#f7f4ed' }}>
      <div className='w-full max-w-[960px] mx-auto px-5 py-8 lg:px-10 lg:py-10'>
        <NotificationContent
          title="Notifications"
          attorney={attorney}
          setLoadNotification={setLoadNotification}
          headerExtra={<SearchContentNotifications userId={userInfo?._id} attorney={attorney}/>}
        />
      </div>
    </div>
  )
}

export default ProfNotificationsWithoutHeader
